import React from 'react';
import { ContactUsProps } from './models';
import { CTAComponent } from '../../Common/UI/client/components/CTA';
import './styles.scss';



export class ContactUs extends React.Component<ContactUsProps> {

  // Load data from JSON config with fallback

  getCTAData = (ctaType: 'primary' | 'secondary') => {
  const contactUsData = this.props.data; // Use props data
  if (!contactUsData) return null;

    if (ctaType === 'primary') {
      if (!contactUsData.text || !contactUsData.url) {
        return null;
      }
      return {
        href: contactUsData.url,
        target: contactUsData.target,
        text: contactUsData.text,
        style: contactUsData.style,
        suffixIcon: contactUsData.suffixIcon === 'true',
        svgContent: contactUsData.icon || null // Add SVG content if available
      };
    }

    if (ctaType === 'secondary') {
      if (!contactUsData.secondaryCta || 
          !contactUsData.secondaryCta.text || 
          !contactUsData.secondaryCta.url) {
        return null;
      }
      return {
        href: contactUsData.secondaryCta.url,
        target: contactUsData.secondaryCta.target,
        text: contactUsData.secondaryCta.text,
        style: contactUsData.secondaryCta.style,
        suffixIcon: contactUsData.secondaryCta.suffixIcon === 'true',
        svgContent: contactUsData.secondaryCta.icon || null
      };
    }

    return null;
  };

  renderCTAButton = (ctaData: any) => {
    if (!ctaData) return null;

    return (
      <CTAComponent
        href={ctaData.href}
        target={ctaData.target}
        text={ctaData.text}
        style={ctaData.style}
        suffixIcon={ctaData.suffixIcon}
        svgContent={ctaData.linkIcon}
        onClick={(event: React.MouseEvent) => {
        }}
      />
    );
  };

  renderContactForm = () => {
  const contactUsData = this.props.data;
  if (!contactUsData) {
      return null;
    }

    return (
      <div 
        className="ge-contact-us"
  data-bgcolor={contactUsData.bgColor}
      >
        <div className="cmp-bg-color fullwidth"></div>
        <div className="contact-us-wrap">
          {contactUsData.eyebrow && (
            <div className="text-eyebrow" dangerouslySetInnerHTML={{ __html: contactUsData.eyebrow }} />
          )}
          {contactUsData.sectionTitle && (
            <div className="title">
              <h2 className="title-m" dangerouslySetInnerHTML={{ __html: contactUsData.sectionTitle }} />
            </div>
          )}
          {(() => {
            const primaryCTA = this.getCTAData('primary');
            const secondaryCTA = this.getCTAData('secondary');
            
            if (!primaryCTA && !secondaryCTA) {
              return null;
            }

            return (
              <div className="cta-wrap">
                {this.renderCTAButton(primaryCTA)}
                {this.renderCTAButton(secondaryCTA)}
              </div>
            );
          })()}
        </div>
      </div>
    );
  };

  render(): React.ReactNode {
  const contactUsData = this.props.data; // Use props data
  if (!contactUsData) {
      return null;
    }

  const hasContent = contactUsData.sectionTitle || contactUsData.text;
    if (!hasContent) {
      return null;
    }

    return (
      <>
        {this.renderContactForm()}
      </>
    );
  }
}

export default ContactUs;
